import { Box, Grid, Paper, Typography } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { useNavigate } from "react-router-dom";
import clsx from "clsx";
import CustomTooltip from "../../common/Tooltip";
import {
  FacebookIcon,
  FacebookShareButton,
  LinkedinIcon,
  LinkedinShareButton,
  TwitterIcon,
  TwitterShareButton,
} from "react-share";
import "./styles.scss";

const useStyles = makeStyles((theme) => ({
  root: {
    padding: "25px 190px",
    [theme.breakpoints.down("md")]: {
      padding: "25px 10px",
    },
  },
  logo: {
    width: "90%",
    [theme.breakpoints.down("sm")]: {
      width: "65%",
    },
  },
  gridItemMiddle: {
    zIndex: 1,
    paddingLeft: "20px",
    display: "flex",
    flexDirection: "column",
    [theme.breakpoints.down("md")]: {
      marginTop: "25px",
    },
  },
  email: {
    [theme.breakpoints.down("md")]: {
      marginTop: "25px",
      paddingLeft: "20px",
    },
  },
  wantMore: {
    textAlign: "right",
    [theme.breakpoints.down("md")]: {
      textAlign: "left",
      marginTop: "25px",
      paddingLeft: "20px",
    },
  },
  contact: {
    display: "flex",
    justifyContent: "right",
    [theme.breakpoints.down("md")]: {
      justifyContent: "left",
      paddingLeft: "20px",
    },
  },
}));

const shareItems = [
  {
    button: FacebookShareButton,
    icon: FacebookIcon,
    url: "https://www.facebook.com/profile.php?id=100068273286928",
    // tooltip: "Share on Facebook",
    tooltip: "Facebook page",
  },
  {
    button: LinkedinShareButton,
    icon: LinkedinIcon,
    url: "https://in.linkedin.com/school/national-institute-of-urban-affairs/",
    tooltip: "Linkedin page",
  },
  {
    button: TwitterShareButton,
    icon: TwitterIcon,
    url: "https://twitter.com/NIUA_India",
    tooltip: "Twitter handle",
  },
].map((item, index) => (
  <CustomTooltip title={item.tooltip}>
    <div>
      <item.icon
        style={{
          height: "30px",
          width: "30px",
          borderRadius: "50%",
          marginLeft: "5px",
          cursor: "pointer",
        }}
        onClick={() => {
          window.open(item.url, "_blank");
        }}
      />
    </div>
  </CustomTooltip>
  // </item.button>
));

const Footer = () => {
  const classes = useStyles();
  const navigate = useNavigate();

  return (
    <Paper elevation={0} className={classes.root}>
      <Grid container alignItems={"center"}>
        <Grid item xs={12} md={3}>
          <img
            src={require("../../assets/citiis.png")}
            alt="citiis"
            className={clsx(classes.logo, "footercitiislogomobile")}
          />
        </Grid>
        <Grid item xs={12} md={2} className="emaildivfooter">
          <Typography variant="thicksmall" className={classes.email}>
            E:{" "}
            <CustomTooltip title="Click here to send mail">
              <a
                href="mailto:citiis@niua.org"
                style={{ textDecoration: "none" }}
                className="footeremail"
              >
                {" "}
                citiis@niua.org
              </a>
            </CustomTooltip>
          </Typography>
        </Grid>
        <Grid item xs={12} md={2} className={classes.gridItemMiddle}>
          <CustomTooltip title={"Terms Of Use & Disclaimer"} position="left">
            <Typography
              variant="thinsmall"
              style={{
                cursor: "pointer",
              }}
              className="footerterms"
              onClick={() => {
                window.open(
                  "https://citiis.niua.in/terms_of_use_CITIIS.pdf",
                  "_blank"
                );
              }}
            >
              Terms Of Use
              <br />
              <Typography component="span" variant="thinsmall">
                & Disclaimer
              </Typography>
            </Typography>
          </CustomTooltip>
          <CustomTooltip title={"Privacy Policy"} position="left">
            <Typography
              style={{
                cursor: "pointer",
              }}
              variant="thinsmall"
              className="footerterms"
              onClick={() => {
                window.open(
                  "https://citiis.niua.in/privacy_policy_CITIIS.pdf",
                  "_blank"
                );
              }}
            >
              Privacy Policy
            </Typography>
          </CustomTooltip>
          {/* <Typography variant="thinsmall">Disclaimer</Typography> */}
        </Grid>
        <Grid item xs={12} md={2} className={classes.gridItemMiddle}>
          {[
            {
              title: "About",
              url: "/whoweare",
              tooltip: "Click here to know about us",
            },
            {
              title: "Projects",
              url: "/project-menu/citiis1",
              tooltip: "Click here to see our projects",
            },
            {
              title: "Resources",
              url: "/publications",
              tooltip: "Click here to see resources",
            },
            {
              title: "Contact",
              url: "/contactus",
              tooltip: "Click here to send mail",
            },
          ].map((item) => (
            <CustomTooltip title={item.tooltip} position="left">
              <Typography
                variant="thinsmall"
                component="div"
                sx={{ cursor: "pointer", width: "fit-content" }}
                onClick={() => {
                  if (item.url) {
                    navigate(item.url);
                  }
                }}
                className="footerabout"
              >
                {item.title}
              </Typography>
            </CustomTooltip>
          ))}
        </Grid>
        <Grid
          item
          xs={12}
          md={3}
          // style={{ textAlign: "right" }}
          className="contbtnfooter"
        >
          {/* <Typography variant="thinsmall" className={classes.wantMore}>
            WANT TO KNOW MORE ABOUT CITIIS?
          </Typography>
          <CustomTooltip title="Click here to contact us">
            <a
              className="btn btn-primary btnstyleourwork"
              href="mailto:citiis@niua.org"
            >
              Contact Us
            </a>
          </CustomTooltip> */}
          <Box
            className={classes.socialWrapper}
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "right",
            }}
          >
            <div style={{ display: "flex" }}>{shareItems}</div>
          </Box>
        </Grid>
      </Grid>
    </Paper>
  );
};

export default Footer;
